<template>
  <div :data-error="error">
    <div ref="toolbar" class="ql-toolbar ql-snow">
      <span class="ql-formats">
        <button tabindex="-1" class="ql-bold" title="Bold"></button>
        <button tabindex="-1" class="ql-italic" title="Italic"></button>
        <button tabindex="-1" class="ql-underline" title="Underline"></button>
        <button tabindex="-1" class="ql-link" title="Link"></button>
      </span>
      <span class="ql-formats">
        <button
          tabindex="-1"
          class="ql-list"
          value="bullet"
          title="Bullets"
        ></button>
        <button
          tabindex="-1"
          class="ql-list"
          value="ordered"
          title="Numbers"
        ></button>
      </span>
      <span class="ql-formats" v-if="imagesEnabled">
        <button tabindex="-1" class="ql-image" title="Image"></button>
      </span>
    </div>
    <reply-to :replyToId="replyToId"></reply-to>
    <div ref="editor"></div>
    <input ref="files" type="text" class="hidden" :required="pendingRequest" />
    <input
      ref="input"
      type="text"
      class="hidden"
      :name="name"
      v-model="htmlContent"
      required
    />
    <portal target-el="#mentionPortal" v-if="mentionDropdownVisible">
      <mention-list :search-query="mentionQuery"></mention-list>
    </portal>
  </div>
</template>

<script>
  import axios from 'axios'

  import ReplyTo from './ReplyTo';
export default {
  name: "TextEditor",
  components: {
    ReplyTo
  },
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    attachable: {
      type: String,
      default: ""
    },
    content: {
      type: String
    },
    name: {
      type: String
    },
    error: {
      type: String
    },
    replyToId: {
      type: [Number, String],
      required: false
    },
    linkifyEnabled: {
      type: Boolean,
      default: true
    },
    mentionsEnabled: {
      type: Boolean,
      default: true
    },
    imagesEnabled: {
      type: Boolean,
      default: true
    },
    maxlength: {
      type: Number,
    },
  },
  data() {
    return {
      fileQueue: [],
      htmlContent: null,
      emptyValue: "<p><br></p>",
      errorClass: "field_with_errors",
      filePath: "/attachments/pictures",
      mentionDropdownVisible: false,
      mentionQuery: ""
    };
  },
  mounted() {
    Quill.prototype.$eventHub = this.$eventHub;

    this.editor = new Quill(this.$refs.editor, {
      theme: "snow",
      placeholder: this.placeholder,
      modules: {
        linkify: this.linkifyEnabled,
        mention: this.mentionsEnabled,
        imageBlob: this.imagesEnabled ? { handler: this.uploadFile } : false,
        toolbar: this.$refs.toolbar,
        keyboard: {
          bindings: {
            enterKey: {
              key: 13,
              shortKey: false,
              handler: this.handleEnter
            }
          }
        }
      }
    });

    this.updateContent();
    this.editor.root.addEventListener("blur", this.blurHandler);
    this.editor.root.addEventListener("focus", this.focusHandler);
    this.editor.root.setAttribute('spellcheck', 'true');

    if (this.maxlength) {
      this.editor.on("text-change", () => {
        const truncLength = this.editor.root.innerHTML.length - this.maxlength
        if (truncLength > 0) {
          this.editor.deleteText(this.editor.getLength() - truncLength - 1, truncLength, 'silent')
        }
      })
    }

    this.$refs.files.addEventListener("invalid", this.filesHandler);
    this.$refs.input.addEventListener("invalid", this.invalidHandler);

    this.$eventHub.$on("mentionAutocompleteSearch", (query) => {
      this.mentionDropdownVisible = true;
      this.mentionQuery = query;
    });

    this.$eventHub.$on("mentionAutocompleteClose", () => {
      this.mentionDropdownVisible = false;
    });

    let tooltip = this.editor.theme.tooltip;
    let input = tooltip.root.querySelector("input[data-link]");
    input.dataset.link = Grabcad.site.community;
  },
  computed: {
    pendingRequest() {
      return this.fileQueue.length > 0;
    }
  },
  watch: {
    content() {
      this.updateContent();
    }
  },
  methods: {
    focus () {
      this.editor.focus();
    },
    updateContent() {
      let activeElement = document.activeElement;
      this.editor.pasteHTML(this.content);
      this.htmlContent = this.content;
      activeElement.focus();
    },
    filesHandler(event) {
      event.preventDefault();
    },
    invalidHandler(event) {
      event.preventDefault();
      this.$el.classList.add(this.errorClass);
    },
    focusHandler() {
      this.$el.classList.remove(this.errorClass);
    },
    blurHandler() {
      let value = this.editor.root.innerHTML;

      if (value !== this.emptyValue) {
        this.htmlContent = value;
      } else if (this.htmlContent !== this.emptyValue) {
        this.htmlContent = "";
      }
    },
    removeFromQueue(response) {
      const blobUrl = response.data.blobUrl;
      this.fileQueue.splice(this.fileQueue.indexOf(blobUrl), 1);
    },
    uploadFile(file, blobUrl) {
      this.fileQueue.push(blobUrl);
      const payload = new FormData();
      payload.append("file", file);
      payload.append("blob_url", blobUrl);
      payload.append("attachable_type", this.attachable);
      axios.post(this.filePath, payload).then(this.removeFromQueue);
    },
    handleEnter () {
      if (this.mentionDropdownVisible)
        this.$eventHub.$emit("mentionAutocompleteConfirm");
      return !this.mentionDropdownVisible;
    }
  }
};
</script>
